import {
    GET_GRILLA_IMPLICADO,
    GET_DATOS_PANTALLA,
    GET_COMBO_SEGURO,
    GET_COMBO_COMPANIAS,
    GET_COMBO_VEHICULOS,
    GET_COMBO_MARCAS,
    GET_COMBO_PAIS,
    GET_COMBO_COMUNAS,
    POST_ACTUALIZAR_IMPLICADO,
    PUT_ADICIONAR_IMPLICADO,
    OBTENER_DATOS_NO_FORMATOS,
    OBTENER_RUT_CONDUCTOR,
    OBTENER_RUT_PROPIETARIO,
    OBTENER_RUT_DESTINATARIO,
    GET_PARAMETROS,
    GET_CONFIG_FORM37,
    GET_COMBO_DESTINATARIO,
    GET_COMBO_MEDIO_PAGO,
    GET_COMBO_INSTITUCION,
    GET_COMBO_TIPO_CUENTA,
    GET_COMBO_TIPO_INVOLUCRADO,
    GET_COMBO_LESIONADO,
    GET_COMBO_GESTION

} from '../types';

export default function implicadoReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM37:
            return { ...state, cfg_form37: action.payload }
        case GET_GRILLA_IMPLICADO:
            return { ...state, grillaImplicado: action.payload }
        case GET_PARAMETROS:
            return { ...state, parametros: action.payload }

        case GET_DATOS_PANTALLA:
            return { ...state, datosPantalla: action.payload }
        case GET_COMBO_SEGURO:
            return { ...state, comboSeguro: action.payload }
        case GET_COMBO_COMPANIAS:
            return { ...state, comboCompanias: action.payload }
        case GET_COMBO_VEHICULOS:
            return { ...state, comboVehiculos: action.payload }
        case GET_COMBO_MARCAS:
            return { ...state, comboMarcas: action.payload }

        case GET_COMBO_PAIS:
            return { ...state, comboPais: action.payload }
        case GET_COMBO_COMUNAS:
            return { ...state, comboComunas: action.payload }
        case POST_ACTUALIZAR_IMPLICADO:
            return { ...state, respuestaImplicado: action.payload }
        case PUT_ADICIONAR_IMPLICADO:
            return { ...state, respuestaAddImplicado: action.payload }
        case OBTENER_DATOS_NO_FORMATOS:
            return { ...state, datosNoFormatos: action.payload }
        case OBTENER_RUT_CONDUCTOR:
            return { ...state, rutConductor: action.payload }
        case OBTENER_RUT_PROPIETARIO:
            return { ...state, rutPropietario: action.payload }
        case OBTENER_RUT_DESTINATARIO:
            return { ...state, rutDestinatario: action.payload }
        case GET_COMBO_DESTINATARIO:
            return { ...state, comboDestinatario: action.payload }
        case GET_COMBO_MEDIO_PAGO:
            return { ...state, comboMedioPago: action.payload }
        case GET_COMBO_INSTITUCION:
            return { ...state, comboInstitucion: action.payload }
        case GET_COMBO_TIPO_CUENTA:
            return { ...state, comboTipoCuenta: action.payload }
        case GET_COMBO_TIPO_INVOLUCRADO:
            return { ...state, comboTipoInvolucrado: action.payload }

        case GET_COMBO_LESIONADO:
            return { ...state, comboLesionado: action.payload }
        case GET_COMBO_GESTION:
            return { ...state, comboGestion: action.payload }

        default:
            return state
    }
}